import { render } from "./AnasayfaView.vue?vue&type=template&id=bb4292f2"
import script from "./AnasayfaView.vue?vue&type=script&lang=js"
export * from "./AnasayfaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__